import React from "react";

interface RoundedChipProps {
  title: String;
  subtitle: String;
  color: String;
}

const RoundedChip: React.FC<RoundedChipProps> = (props: RoundedChipProps) => {
  const { title, color, subtitle } = props;
  return (
    <div className="flex gap-4">
      <div className={`my-auto ${color} w-2 h-2 rounded-md`}></div>
      <div>
        <p className="text-sm font-semibold">{title}</p>
        <p className="text-sm font-bold">{subtitle}</p>
      </div>
    </div>
  );
};

export default RoundedChip;
